export default "__VITE_ASSET__CvTULoP7__"